import React from 'react';
import { TableRow, TableCell, Checkbox, IconButton, Typography, Switch, Chip } from '@mui/material';
import { MoreVert as MoreIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const ShippingZonesTableRow = ({
    item,
    index = 0,
    isSelected,
    onRowCheckboxClick,
    onMenuOpen,
    onToggleActive,
}) => {
    const { i18n } = useTranslation();
    const lng = i18n.language || 'en';

    const name = item.name?.[lng] || item.name?.en || item.name?.ar || item.name || '-';
    const locationsCount = item.locations_count ?? item.locations?.length ?? 0;
    const methodsCount = item.methods_count ?? item.shipping_methods_count ?? item.methods?.length ?? 0;

    return (
        <TableRow hover selected={isSelected}>
            <TableCell padding="checkbox">
                <Checkbox checked={isSelected} onClick={(e) => onRowCheckboxClick(e, item.id)} />
            </TableCell>

            <TableCell align="start">{index + 1}</TableCell>

            <TableCell>
                <Typography variant="body2" fontWeight="medium">{name}</Typography>
            </TableCell>

            <TableCell align="center">
                <Chip
                    size="small"
                    label={locationsCount}
                    color={locationsCount > 0 ? 'primary' : 'default'}
                    variant="tonal"
                    sx={{ fontWeight: 'bold', borderRadius: '6px', minWidth: '40px' }}
                />
            </TableCell>

            <TableCell align="center">
                <Chip
                    size="small"
                    label={methodsCount}
                    color={methodsCount > 0 ? 'success' : 'default'}
                    variant="tonal"
                    sx={{ fontWeight: 'bold', borderRadius: '6px', minWidth: '40px' }}
                />
            </TableCell>

            <TableCell align="center">
                <Switch
                    checked={!!item.is_active}
                    onChange={() => onToggleActive?.(item)}
                    color="primary"
                    size="small"
                />
            </TableCell>

            <TableCell align="center">
                <IconButton size="small" onClick={(e) => onMenuOpen(e, item)}>
                    <MoreIcon />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default ShippingZonesTableRow;
